import {
  ByIdPayload,
  ChangeParamsByIdPayload,
  FailByIdPayload,
  ListReducerTypes,
  NormalizedList,
  PayloadAction,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { SymfonyPaginationParams } from '../../../../symfony/list/models/symfony-pagination-params';

export const ServiceProjectPartLoadListActionTypes: ListReducerTypes = {
  request: uniqueActionType('[service/project-part] Load list'),
  requestFail: uniqueActionType('[service/project-part] Load list fail'),
  requestSuccess: uniqueActionType('[service/project-part] Load list success'),
  requestClear: uniqueActionType('[service/project-part] Load list clear'),
  changeParams: uniqueActionType('[service/project-part] Load list change params'),
  clearParams: uniqueActionType('[service/project-part] Load list clear params'),
  clearIds: uniqueActionType('[service/project-part] Load list clear ids')
};

export class ServiceProjectPartLoadListAction implements PayloadAction {
  readonly type = ServiceProjectPartLoadListActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class ServiceProjectPartLoadListFailAction implements PayloadAction {
  readonly type = ServiceProjectPartLoadListActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class ServiceProjectPartLoadListSuccessAction implements PayloadAction {
  readonly type = ServiceProjectPartLoadListActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedList>) {
  }
}

export class ServiceProjectPartLoadListClearAction implements PayloadAction {
  readonly type = ServiceProjectPartLoadListActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}

export class ServiceProjectPartLoadListChangeParamsAction implements PayloadAction {
  readonly type = ServiceProjectPartLoadListActionTypes.changeParams;

  constructor(public payload: ChangeParamsByIdPayload<SymfonyPaginationParams>) {
  }
}

export class ServiceProjectPartLoadListClearParamsAction implements PayloadAction {
  readonly type = ServiceProjectPartLoadListActionTypes.clearParams;

  constructor(public payload: ByIdPayload) {
  }
}


export class ServiceProjectPartLoadListClearIdsAction implements PayloadAction {
  readonly type = ServiceProjectPartLoadListActionTypes.clearIds;

  constructor(public payload: ByIdPayload) {
  }
}
